export default function UseCases({ t }) {
  return (
    <section id="usecases" className="usecases">
      <div className="container">
        <div className="reveal usecases-card">
          <div className="usecases-blob" />
          <div className="usecases-head">
            <div className="eyebrow">{t.eyebrow}</div>
            <h2>{t.title}</h2>
            <p>{t.lead}</p>
          </div>
          <div className="usecases-grid">
            {t.items.map((u, idx) => (
              <div className="usecase" key={u.title}>
                <div className="usecase-num">{idx + 1}</div>
                <div className="t">{u.title}</div>
                <div className="b">{u.body}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
